var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvBenefitsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5C15.3 3.5 13.5 3.4 13.5 1.5C13.5 1.2 13.3 1 13 1C12.7 1 12.5 1.2 12.5 1.5C12.5 1.7 12.4 3.5 10.5 3.5C10.2 3.5 10 3.7 10 4C10 4.3 10.2 4.5 10.5 4.5C10.7 4.5 12.5 4.6 12.5 6.5C12.5 6.8 12.7 7 13 7C13.3 7 13.5 6.8 13.5 6.5C13.5 6.3 13.6 4.5 15.5 4.5C15.8 4.5 16 4.3 16 4C16 3.7 15.8 3.5 15.5 3.5Z",
    fill: "#F9C606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5C14.3 12.5 12.5 12.4 12.5 10.5C12.5 10.2 12.3 10 12 10C11.7 10 11.5 10.2 11.5 10.5C11.5 10.7 11.4 12.5 9.5 12.5C9.2 12.5 9 12.7 9 13C9 13.3 9.2 13.5 9.5 13.5C9.7 13.5 11.5 13.6 11.5 15.5C11.5 15.8 11.7 16 12 16C12.3 16 12.5 15.8 12.5 15.5C12.5 15.3 12.6 13.5 14.5 13.5C14.8 13.5 15 13.3 15 13C15 12.7 14.8 12.5 14.5 12.5Z",
    fill: "#F9C606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 6.8L8.9 6.4C7.8 6.1 6.9 5.3 6.6 4.1L6.2 2.6C6 1.8 4.9 1.8 4.7 2.6L4.4 4.1C4.1 5.2 3.3 6.1 2.1 6.4L0.6 6.8C-0.2 7 -0.2 8.1 0.6 8.3L2.1 8.7C3.2 9 4.1 9.8 4.4 11L4.8 12.5C5 13.3 6.1 13.3 6.3 12.5L6.7 11C7 9.9 7.8 9 9 8.7L10.5 8.3C11.2 8.1 11.2 6.9 10.4 6.8Z",
    fill: "#F9C606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvBenefitsSmall);
export default __webpack_public_path__ + "static/media/grv-benefits-small.0cb81db5292d11fd82343bbad75414ee.svg";
export { ForwardRef as ReactComponent };